import { render } from "./step-five.vue?vue&type=template&id=41a37d3e&scoped=true"
import script from "./step-five.vue?vue&type=script&lang=js"
export * from "./step-five.vue?vue&type=script&lang=js"

import "./step-five.vue?vue&type=style&index=0&id=41a37d3e&scoped=true&lang=css"

import exportComponent from "/Users/matthiasswiercz/PhpstormProjects/sksturm/custom/plugins/SkSturmTheme/src/Resources/app/storefront/childBook/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a37d3e"]])

export default __exports__